import { Task, TaskStatus } from '@bringg/types';

export const getRouteFulfillment = (
	tasks: Task[]
): { completed: number; partial_completed: number; canceled: number } => {
	return tasks.reduce(
		(acc, task) => {
			if (task.status === TaskStatus.Cancelled) {
				acc.canceled += 1;
			}

			if (task.status === TaskStatus.Done) {
				const isRejected = task?.aggregations?.has_any_rejected_inventory;

				if (isRejected) {
					acc.partial_completed += 1;
				} else {
					acc.completed += 1;
				}
			}

			return acc;
		},
		{ canceled: 0, completed: 0, partial_completed: 0 }
	);
};
